class FirehawkCheckoutDDModal {
    container = null
    paymentIntent = null

    modalElement = null
    modal = null
    useTestPayments = false
    paymentProviderApiKey = null
    adyenClientKey = null

    adyenDropinComponent = null
    loadingPaymentProvider = true
    hasSetupPaymentProvider = false

    constructor(paymentIntent, options) {
        this.paymentIntent = paymentIntent

        this.container = options.container
        this.useTestPayments = options.useTestPayments == true
        this.paymentProviderApiKey = options.paymentProviderApiKey
        this.adyenClientKey = options.adyenClientKey
    }

    addListeners() {
        this.modalElement.delegate(".close-modal-btn", "click", (event) => {
            this.closeDetailsModal()
        })

        this.modalElement.on('hidden.bs.modal', (event) => {
            if (this.modal) {
                this.modal.dispose()
            }
            if (this.modalElement) {
                this.modalElement.remove()
            }

            this.modal = null
            this.modalElement = null
        })
    }

    configureAdyen() {
        if (!this.paymentIntent) return

        const configuration = {
            environment: this.useTestPayments ? "test" : 'live',
            clientKey: this.paymentProviderApiKey || this.adyenClientKey,
            analytics: {
                enabled: true
            },
            session: {
                id: this.paymentIntent.id,
                sessionData: this.paymentIntent.sessionData
            },
            onPaymentCompleted: (result, component) => {
                this.onPaymentSuccess(result, component)
            },
            onPaymentFailed: (result, component) => {
                console.log(result, component);
            },
            onError: (error, component) => {
                console.error(error.name, error.message, error.stack, component);
            }
        }

        AdyenWeb.AdyenCheckout(configuration).then((checkout) => {
            if (this.adyenDropinComponent) checkout.remove(this.adyenDropinComponent);
            this.adyenDropinComponent = new AdyenWeb.Dropin(checkout, {
                paymentMethodsConfiguration: {
                    card: {
                        hasHolderName: true,
                        holderNameRequired: true,
                        billingAddressRequired: false
                    }
                }
            }).mount('#fh-direct-debit-details');
            this.hasSetupPaymentProvider = true
            this.loadingPaymentProvider = false

            jQuery(this.modalElement).find(".payment-loading-placeholder").hide()
        }).catch(error => {
            console.log(error)
            this.loadingPaymentProvider = false
            jQuery(this.modalElement).find(".payment-loading-placeholder").hide()
        })
    }

    buildModal() {
        let modalContainer = jQuery(`<div class="bs-modal modal fade stock-detail-modal" tabindex="-1" style="display: none;" aria-hidden="true"></div>`)
        let modal = jQuery('<div class="modal-dialog modal-lg modal-dialog-centered"></div>')
        let modalContent = jQuery('<div class="modal-content">')

        modalContent.append(jQuery(`
            <div class="modal-header">
                <h5 class="modal-title">Instalments Direct Debit Details</h5>
            </div>
        `))

        // Setup: Modal body
        let modalBody = jQuery('<div class="modal-body"></div>')

        modalBody.append(jQuery(`<div class="payment-loading-placeholder">
        <div class="fcrms-spinner primary lg"></div></div>`))
        modalBody.append(jQuery('<div id="fh-direct-debit-details"></div>'))

        // modalBody.append(stockInfo)

        modalContent.append(modalBody)
        modal.append(modalContent)
        modalContainer.append(modal)
        return modalContainer
    }

    show() {
        let modalElement = jQuery(this.buildModal())

        if (this.container) {
            jQuery(this.container).append(modalElement)
        } else {
            jQuery("body").append(modalElement)
        }

        this.modalElement = modalElement
        this.modal = new bootstrap.Modal(modalElement.get(0), {
            keyboard: false,
            backdrop: "static"
        })
        this.modal.show()

        this.addListeners()
        this.configureAdyen()
    }

    hide() {
        this.modal.hide()
    }

    onPaymentSuccess(result, component) {
        console.log(result)
    }
}
